export default __webpack_public_path__ + "media/images/up-arrow-9b845b0ce42030f670c72b90ccef826e.svg";